import { createRequest, getAccessToken } from './config';

const request = createRequest();

export const Project = {
  getProjectById: (id) =>
    request.get(`/project/id/${id}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getProjectByReferenceNumber: (referencenumber) =>
    request.get(`/project/referencenumber/${referencenumber}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getProjects: (lastId, navId) =>
    request.get(`/project?${navId}=${lastId}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
    getProjectsByFilters: (searchString, startYear, endYear, lastId, navId, i, type) => {
      const params = new URLSearchParams();
    
      if (searchString) params.append("searchString", searchString);
      if (startYear) params.append("startYear", startYear);
      if (endYear) params.append("endYear", endYear);
      if (lastId && navId) params.append(navId, lastId);
      if (i) params.append("i", i);
      if (type) params.append("type", type);
    
      return request.get(`/project/filters?${params.toString()}`, {
        headers: { Authorization: `Bearer ${getAccessToken()}` }
      });
    },
    
  // getProjectsByFilters: (searchString, startYear, endYear, lastId, navId, i, type) =>
  //   request.get(`/project/filters?searchString=${encodeURIComponent(searchString)}&startYear=${startYear}&endYear=${endYear}&${navId}=${lastId}&i=${i}&type=${type}`, {
  //     headers: { Authorization: `Bearer ${getAccessToken()}` }
  //   }),
  updateProjectById: (id, data) =>
    request.patch(`/project/id/${id}`, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getProjectByClient: (clientId) =>
    request.get(`/project/client/${clientId}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    }),
  
  getProjectByProfessional: (professionalId) =>
    request.get(`/project/professional/${professionalId}`, {
      headers: { Authorization: `Bearer ${getAccessToken()}` }
    })
};

export default Project;
